import React from "react";
import { Row, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { gaEvent } from "analytics/analytics";
import * as GA from "constants/analytics";

export default function BreadcrumbComponent() {
  return (
    <Row>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/" onClick={() => {
              gaEvent(GA.EVENT.CLICK, GA.CATEGORY.RETURN, GA.DESCRIPTION.RETURN_TO_HOME);
            }}> Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          {" "}
          <Link to="/create-collection" onClick={() => {
              gaEvent(GA.EVENT.CLICK, GA.CATEGORY.RETURN, GA.DESCRIPTION.RETURN_TO_CREATE_CATALOGUE);
            }}> Create Catalogue</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item> Select Products</Breadcrumb.Item>
      </Breadcrumb>
    </Row>
  );
}
